import styled from 'styled-components';
import {OzobotSvg} from "./OzobotSvg";

export const OzobotImage = styled(OzobotSvg)`
    position: absolute;
    display: grid;
    
    & svg {
        height: 100%;
        width: 100%;
        margin-left: ${props => props.margin}px;
        margin-top: ${props => props.marginX}px;
        
        shape-rendering: geometricPrecision; 
        text-rendering: geometricPrecision; 
        image-rendering: optimizeQuality; 
        fill-rule: evenodd; 
        clip-rule: evenodd;
    }
    
    &:hover svg {
        transform: scale(1.1);
    }
    
    &:hover .fil2 {
        fill: #008CFF;
    }
    
    & .fil1 {
        fill: black;
    }
    & .fil3 {
        fill:#666666;
    }
    & .fil0 {
        fill:#999999;
    }
    & .fil2 {
        fill: ${props => {
            switch (props.color) {
                case 'red': 
                    return '#E31E24';
                case 'green':
                    return 'lime';
                case 'blue':
                    return '#008CFF';
                case 'white':
                    return '#FFF';
                case 'purple':
                    return '#d000ff';
                default:
                    return '#A8A8A8'; 
            }
        }};
        fill-opacity:0.701961
    }
`;



// WEBPACK FOOTER //
// ./src/Simulator/Ozobot/OzobotStyles.js